import styled from '@emotion/styled';

export const ButtonsWrapper = styled('div')({
  display: 'flex',
  width: 459,
  gap: 10,
  justifyContent: 'flex-end',
});
